// src/environments/environment.ts (desarrollo)
export const environment = {
  production: false,
  idIbero: '876',
  idIberoVirtual: '',
  // urlFrontEnd: 'http://localhost:4200',
  urlFrontEnd: 'https://siteit.pages.dev',
  apiUrlSSO: 'https://login-universal-test.azurewebsites.net/api',
  apiUrl: 'https://as-ws-zyon-test-keycloak.azurewebsites.net/api/v1',
  iberoApiUrl: 'https://as-ws-ibero-views.azurewebsites.net',
  auth: {
    oktaConfig: {
      clientId: '0oanytwg4yEYRIa0S417',
      issuer: 'https://psoplaneta.okta.com',
      redirectUri: window.location.origin,
    },
    msalConfig: {
      clientId: '5195a692-8394-4c16-9db9-a5af32c8c443',
      authority: 'https://login.microsoftonline.com/ba5b0a4d-6c68-4ac3-9d6e-c5b5a12a9d69',
      redirectUri: 'https://siteit.pages.dev'
    }
  },
  storage: {
    blobUrl: 'https://strg01tockall.blob.core.windows.net'
  }
};